



















import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class ModalConfirmPaymentFail extends Vue {
  @Prop({ default: "" }) partnerName!: string;
  private showModal = true;

  @Watch("showModal")
  showModalChanged() {
    if (!this.showModal) {
      this.HideModal();
    }
  }

  public HideModal() {
    this.$emit("update:showModal", false);
  }
}
